import { vslApi } from '@/api';

export default Object.freeze({
  fetchMyDebitList(params) {
    return vslApi.get(`/v1/public-ebookings/my-debits`, {
      params,
    });
  },
});
